import * as React from 'react';
import { Survey } from 'survey-react-ui';
import { Model } from 'survey-core/survey.core';

type Props = {
  model: Model;
};
export const MemoSurvey = React.memo(({ model }: Props) => {
  return <Survey model={model} />;
});
